<template>
  <div class="mainDiv">
    <h3 style="margin-bottom: 20px" v-if="courseName">{{ courseName }}</h3>
    <div style="position: relative">
      <el-tabs v-model="reviewStatus" type="card">
        <el-tab-pane
          v-for="item in reviewStatusList"
          :key="item.value"
          :label="item.label"
          :name="item.name"
        ></el-tab-pane>
      </el-tabs>
      <div class="btn" style="position: absolute; top: 4px; right: 8px">
        <el-button type="info" size="small" @click="goBack">返回</el-button>
      </div>
    </div>
    <!-- 检索栏 -->
    <div class="tab">
      <div class="control">
        <el-col :span="6">   
            <el-input v-model="form.fullname" clearable  placeholder="-请输入姓名"></el-input>
        </el-col>
        <el-col :span="6">
            <el-input v-model="form.admissionCard" clearable placeholder="-请输入准考证号"></el-input>
        </el-col>
        <el-button type="primary" size="mini" @click="search">确定</el-button>
        <el-button type="primary" size="mini" @click="exportExamList">导出准考证列表</el-button>
        <el-button type="primary" size="mini" @click="lookCard">打印准考证</el-button>
        <el-button type="primary" size="mini" @click="setOfflineExam">修改考试安排</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        label="ID"
        width="60"
        align="center"
        header-align="center"
        prop="rowNum"
      >
      </el-table-column>
      <el-table-column
        prop="fullname"
        label="姓名"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="admissionCard"
        label="准考证号"
        align="center"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="userCard"
        label="身份证号"
        align="center"
        header-align="center"
       
      ></el-table-column>
       <el-table-column
        prop="phone"
        label="手机号(账号)"
        align="center"
        header-align="center"
       
      ></el-table-column>
      <el-table-column
        prop="examLocationName"
        :label="'考点名称'"
        align="center"
        header-align="center"
       
      ></el-table-column>
      <el-table-column
        prop="examLocationAddress"
        label="考点地址"
        align="center"
        header-align="center"
      
      >
      </el-table-column>
      <el-table-column
        prop="examTimeStr"
        label="考试时间"
        align="center"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="roomName"
        label="教室"
        align="center"
        header-align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="seatNumber"
        label="座位号"
        align="center"
        header-align="center"
        width="80"
      ></el-table-column>
      <!-- <el-table-column
        prop="uname"
        label="操作"
        width="100"
        align="center"

      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                lookCard(
                  scope.row.examsPaperId,
                  scope.row.courseName,
                  scope.row.examsPaperTitle
                )
              "
              >查看</span
            >
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <!-- 修改考试信息弹窗 -->
    <el-dialog
      title="线下考试设置"
      :visible.sync="offlineExam"
      class="score_status_time_dialog"
      width="670px"
      @close="closeOfflineExam"
    >
      <div class="t_export">
        <el-form ref="examFormDate"  :model="examFormDate" :rules="examFormDateRule" label-width="130px" size="mini">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="classRoom" label="已安排试室:">
                <el-select  v-model="examFormDate.classRoom" placeholder="请选择试室" @change="visibleChange">
                    <el-option v-for="item in roomList" :key="item.id" :label="item.examRoom"
                      :value="item.id">
                    </el-option>
                </el-select>
             </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="examName" label="考点名称:">
                <el-input v-model="examFormDate.examName"></el-input>
             </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="examAdd" label="考点地址:">
                <el-input v-model="examFormDate.examAdd"></el-input>
             </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="examRoom" label="室试:">
                <el-input v-model="examFormDate.examRoom"></el-input>
             </el-form-item>
            </el-col>
            <el-col :span="20">
              <el-form-item prop="examTime" label="考试时间：">
                 <el-col :span="7">
                  <el-date-picker
                  v-model="examFormDate.examDate"
                    type="date"
                    @change="getNewDate"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-col>
                |
                <el-col :span="10">
                  <el-time-select
                    placeholder="开始时间"
                    v-model="examFormDate.startTime"
                    :disabled="isDisabled"
                    :picker-options="{
                       start: '08:00',
                       step: '00:15',
                       end: '21:30',
                       minTime: newTime
                  }">
                  </el-time-select>
                </el-col>
                |
                <el-col :span="2">
                  <el-time-select
                  placeholder="结束时间"
                  v-model="examFormDate.endTime"
                  :disabled="isDisabled"
                  :picker-options="{
                     start: '08:00',
                     step: '00:15',
                     end: '21:30',
                     minTime: examFormDate.startTime
                  }">
                </el-time-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" size='small' @click="setOfflineTest">确 定</el-button>
        <el-button type="primary" size='small' @click="closeOfflineExam">返 回</el-button>
      </div>
    </el-dialog>

  <!-- 打印弹窗 -->
    <el-dialog
      title="预览准考证"
      :visible.sync="dialogVisible"
      width="890px"
      @close="cancel"
    >
      <div ref="printCount">
        <!-- 背景图 -->
        <div class="img-bg">
          <img class="bg" src="@/static/images/card-bg.png" alt="" />
          <div class="title">2022年3月华南理工大学高等教育自学考试</div>
          <div class="card">准考证</div>
          <el-table
            :show-header="false"
            :data="tableData2"
            :span-method="objectSpanMethods"
            :cell-style="rowStyle"
            style="margin-top: 0;z-index:9999;background-color:rgba(255, 255, 255,.4)"
            border
          >
            <el-table-column width="180" prop="name"></el-table-column>
            <el-table-column prop="amount1"></el-table-column>
            <el-table-column width="180" prop="amount2"></el-table-column>
            <el-table-column prop="amount3"></el-table-column>
            <el-table-column prop="id" label="ID" width="160">
              <template slot-scope="scope">
                <div>
                  <img class="avatar" :src="scope.row.id" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-table
          :data="tableDatas"
          :span-method="objectSpanMethod"
          :cell-style="rowStyle"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="name" align="center" label="考试时间">
          </el-table-column>
          <el-table-column prop="amount1" align="center" label="课程代码及名称">
          </el-table-column>
          <el-table-column prop="amount2" align="center" label="试室">
          </el-table-column>
          <el-table-column prop="amount3" align="center" label="座位号">
          </el-table-column>
        </el-table>
        <el-table
          :data="tableDatas1"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="name" label="注意事项"> </el-table-column>
        </el-table>
      </div>

      <!-- 操作部分 -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button type="primary" @click="printCard"> 打印 </el-button>
        <el-button @click="cancel">返回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// 综合测验接口
import * as api from '@/api/TeacherClassroomManagement/MyClassroomTution/admissionTicket.js'
import html2canvas from "html2canvas";
import printJS from "print-js";
export default {
  components: {},
  data() {
    return {
      reviewStatusList: [{ value: '0', label: '准考证列表', name: '0' }],
      reviewStatus: '0',
      // 路由携参
      courseId: this.$route.query.courseId,
      batchId: this.$route.query.batchId,
      courseName: this.$route.query.courseName,
      id: this.$route.query.id,
      // 打印准考证
      dialogVisible: false,
      tableData2: [
        {
          id: "https://img2.baidu.com/it/u=428561421,1547551643&fm=253&fmt=auto&app=138&f=PNG?w=388&h=500",
          name: "准考证号",
          amount1: 25,
          amount2: "身份证号",
          amount3: "3607821975846245x",
        },
        {
          id: 54,
          name: "姓名",
          amount1: "赵小雨",
          amount2: "专业",
          amount3: "计算机网络",
        },
        {
          name: "考点名称",
          amount2: "华南理工大学（五三校区）",
        },
        {
          name: "考点地址",
          amount2: "广州市",
        },
      ],
      tableDatas: [
        {
          name: "2022-04-28 00:00-12:00",
          amount1: "0234-色彩",
          amount2: "科学院801",
          amount3: "科学院802",
        },
        {
          name: "2022-03-18 09:00-13:00",
          amount1: "0624-色彩",
          amount2: "研究院504",
          amount3: "研究院307",
        },
      ],
      tableDatas1: [
        {
          name: "1.考前30分钟凭本准考证、有效身份证参加考试;开考15分钟后禁止进入考场;交卷出场不得早于考试开始后1小时，出场后不得再进入考场。",
        },
        {
          name: "2.除必要文具外，其他任何物品不得带入考场。3.考生领取试卷后须仔细核对试卷课程是否正确、有无缺页、缺题、字迹不清等现象，如有须立即向监考员报告。",
        },
        {
          name: "3.考生领取试卷后须仔细核对试卷课程是否正确、有无缺页、缺题、字迹不清等现象，如有须立即向监考员报告。",
        },
        {
          name: "4.考生参加考试时应严格遵守《广东省高等教育自学考试考场规则》",
        },
        {
          name: "5.本准考证用普通A4纸打印，严禁伪造、变造或擅自涂改。",
        },
      ],
      //检索参数 courseName,examsPaperId
      form: {
        fullname:"",
        admissionCard:"",
      },
      offlineExam: false,  // 线下考试弹窗
      examFormDate:{
        classRoom:'',
        examName:'',
        examAdd:'',
        examRoom:'',
        examDate:'',
        startTime: '',
        endTime: ''
      },
      // 已安排考试
      roomList:[],
      // 下拉选中id
      roomId:'',
      examFormDateRule:{
        classRoom:[{ required: true, message: '请选择已安排试室', trigger: 'change'}],
        examName:[{ required: true, message: '请输入考点名称', trigger: 'blur' }],
        examAdd:[{ required: true, message: '请输入考点名称', trigger: 'blur' }],
        examRoom:[{ required: true, message: '请输入考点名称', trigger: 'blur' }],
        examDate:[{ required: true, message: '请设置日期', trigger: 'blur' }],
        // startTime:[{ required: true, message: '请设置开始时间', trigger: 'blur' }],
        // endTime:[{ required: true, message: '请设置结束时间', trigger: 'blur' }],
      },
      // 选择框的数据选中班次id数组
      selectedList: [],
      // 选中的班次id处理成字符串
      selectedListId:'',
      tableData: [],
       //   分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,

      newTime:'',
      pickerOptions: {
        disabledDate(time) {
          // 86400000为1天时间戳
          return time.getTime() < Date.now() - 86400000;
        },
      },
     
      isDisabled:true,
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  created() {
    this.getExamCardList()
    this.getClassList()
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  methods: {
    // 准考证列表
    async getExamCardList() {
      console.log('forms',this.form)
      const { data, code } = (
        await api.getExamCardList({
          ...this.form,
          uid: this.getUId,
          batchId: this.batchId,
          ...this.pageObj,
        })
      ).data
      console.log("准考证列表",data);
      if (code === 100000) {
        if(data.page.list.length> 0){
          console.log("请求数据===》",data);
          this.tableData = data.page.list
          this.total = data.page.total
        }else{
           this.tableData = []
        }
        
      }
    },
    // 查询考试安排信息
    async getExamSet(){
       const { data, code } = (
        await api.getExamSet({
          batchId: this.batchId,
          id: this.roomId
        })
      ).data
      if (code === 100000) {
        console.log("获取考试安排===》",data);
         this.examFormDate.examName = data.examLocationName
         this.examFormDate.examAdd = data.examLocationAddress
         this.examFormDate.examRoom = data.roomName
         this.examFormDate.examDate = data.examDate
         this.examFormDate.startTime = data.examStartTime
         this.examFormDate.endTime = data.examEndTime
         this.id = data.id
  
      }
    },
    // 比较时间大小
    CompareDate(t1,t2){
        var date = new Date();
        var a = t1.split(":");
        var b = t2.split(":");
        return date.setHours(a[0],a[1]) < date.setHours(b[0],b[1]);
    },
    // 获取选中时间
    getNewDate(e){
      // 选中时间
      let selectDate = new Date(e)*1
      this.isDisabled = false
      let myDate = new Date();
      // 处理后成与选中时间格式一样
      let newDates  = myDate.getFullYear() +'-' + (myDate.getMonth() +1) + '-' + myDate.getDate()
      // 处理后时间
      let newDate = new Date(newDates)*1
      console.log(selectDate,newDate);
      if(selectDate == newDate){
        let h = myDate.getHours(); // 获取当前小时数(0-23)
        let m = myDate.getMinutes(); // 获取当前分钟数(0-59)
        let timeStr = h + ':' + (m - 1);
        console.log(timeStr);
        this.newTime = timeStr
        return timeStr
      }else{
        this.newTime = '07:00'
      }
    },
    // 修改考试安排信息
    async saveOrUpdate() {
      if(!this.examFormDate.classRoom){
        this.$message({
          message: "请选择已安排试室",
          type: "error",
        });
        return
      }else if(!this.examFormDate.examName){
        this.$message({
          message: "请输入考点名称",
          type: "error",
        });
        return
      }else if(!this.examFormDate.examAdd){
        this.$message({
          message: "请输入考点地址",
          type: "error",
        });
        return
      }else if(!this.examFormDate.examRoom){
        this.$message({
          message: "请输入试室",
          type: "error",
        });
        return
      }else if(!this.examFormDate.examDate){
         this.$message({
          message: "请设置考试日期",
          type: "error",
        });
        return
      }else if(!this.examFormDate.startTime || this.examFormDate.startTime == '') {
        this.$message({
          message: "请设置开始时间",
          type: "error",
        });
        return
      }else if(!this.examFormDate.endTime || this.examFormDate.endTime == '') {
        this.$message({
          message: "请设置结束时间",
          type: "error",
        });
        return
      }else if(this.CompareDate(this.examFormDate.startTime,this.examFormDate.endTime) == false){
        this.$message({
          message: "开始时间不能小于结束时间",
          type: "error",
        });
        return
      }

      const { code, msg } = (
        await api.saveOrUpdate({
          batchId:this.batchId, // 批次id
          uid: this.getUId, // 操作人id
          id:this.id,
          examLocationName:this.examFormDate.examName,  // 考点名称
          examLocationAddress:this.examFormDate.examAdd, //  考点地址
          roomName:this.examFormDate.examRoom,  // 试室
          examDate:this.examFormDate.examDate , // 考试日期
          examStartTime:this.examFormDate.startTime, // 考试开始时间
          examEndTime:this.examFormDate.endTime, // 考试结束时间
        })
      ).data;
      if (code === 100000) {
        this.$message({
          message: "修改成功",
          type: "success",
        });
        //  需要重新调用查询接口
        //  this.getExamSet()
         this.getExamCardList()
        //  需要更新下拉框数据
        this.getClassList()
        this.offlineExam = false
      } else {
        this.$message.error(msg);
      }
    },
    // 获取已安排列表
    getClassList(){
      const params = {
        batchId: this.batchId, // 批次id
      }
      api.getExamRoomsByBatchId(params).then(({ data }) => {
        if (data.code == 100000) {
          this.roomList = data.data
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 键盘设置
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },

    //搜索
    search() {
      this.pageObj.page = 1;
      this.getExamCardList();
      this.isSeach = true;
    },
        //清空搜索内容
    delAll() {
      this.form.courseName="",
      this.form.examsPaperId="",
      this.pageObj.page = 1
      this.getExamCardList()
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr;
      let ids = this.selectedList.map(v=>{return v.id})
      this.selectedListId = ids.join(',')
      console.log('--->',arr)
      console.log('====>',this.selectedListId)
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getExamCardList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getExamCardList()
    },

    // // 点击确认导出准考证
    exportExamList(){
      if(this.selectedList.length > 0){
        // this.selectedListId
        window.open(
          `${this.url}/zkfz/zkolExamsSeat/exportZkolExamsSeat?batchId=${this.batchId}&uid=${localStorage.getItem('uid')}&ids=${ this.selectedListId }`
        )
      }else{
        window.open(
          `${this.url}/zkfz/zkolExamsSeat/exportZkolExamsSeat?batchId=${this.batchId}&uid=${localStorage.getItem('uid')}&admissionCard=${ this.form.admissionCard}&fullname=${this.form.fullname}`
        )
      }
    },

    // 返回
    goBack() {
      this.$router.push('/MyClassroomTution')
    },

    // 设置线下考试弹窗
    setOfflineExam(){
      this.examFormDate.classRoom = ''
      this.examFormDate.examName = '',  // 考点名称
      this.examFormDate.examAdd = '', //  考点地址
      this.examFormDate.examRoom = '',  // 试室
      this.examFormDate.examDate = '' , // 考试日期
      this.examFormDate.startTime = '', // 考试开始时间
      this.examFormDate.endTime = '', // 考试结束时间
      this.offlineExam = true
    },
    // 关闭线下考试设置弹窗
    closeOfflineExam(){
      this.offlineExam = false
      // 防止修改了数据但未保存时，下次进入存在上次输入数据
      this.getExamSet()
    },
    // 修改线下考试内容
    setOfflineTest(){
      this.saveOrUpdate()
    },
    // 返回
    cancel() {
      this.dialogVisible = false;
    },
    // 表格中间部分
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
     
    },
    // 合并表格rowIndex(行)、columnIndex（列） （表格上部分）
    objectSpanMethods({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 2 || rowIndex === 3) {
        if (columnIndex === 2) {
          return [1, 3];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
      if (columnIndex === 4) {
        if (rowIndex % 5 === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 属性居中显示
    rowStyle() {
      return "text-align:center";
    },
    // 查看准考证
    lookCard() {
      // this.dialogVisible = true;
      if(this.selectedList.length > 0){
        // this.selectedListId
        window.open(
          `${this.url}/zkfz/examinationCard/downloadZIP?batchId=${this.batchId}&uid=${localStorage.getItem('uid')}&ids=${ this.selectedListId }`
        )
      }else{
        window.open(
          `${this.url}/zkfz/examinationCard/downloadZIP?batchId=${this.batchId}&uid=${localStorage.getItem('uid')}&admissionCard=${ this.form.admissionCard}&fullname=${this.form.fullname}`
        )
      }
    },
    // 打印准考证
    printCard() {
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // 转图片打印
      html2canvas(this.$refs.printCount, {
        scale: 2,
      }).then((canvas) => {
        const url = canvas.toDataURL();
        this.img = url;
        console.log(this.img);
        printJS({
          printable: url,
          type: "image",
          documentTitle: "",
        });
      });
    },
    // 导出筛选列表

    // 下拉框
    visibleChange(val) {
      this.roomId = val
      if(this.roomId){
        this.getExamSet()
        console.log(val);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
/deep/.el-collapse {
  padding-bottom: 20px;
}

.table_control {
  color: #409eff;
  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
.t_export{
  margin: 0 auto;
  text-align: center;
}
.t_exportTitle{
  margin-bottom: 20px;
}
.t_count{
  color:red;
  font-weight: 600;
}
/deep/.el-dialog__header {
  background-color: #d7d7d7;
}
// /deep/ .el-table .cell{
//     font-size: 18px;
//     color: #000000;
//     后期在改，此处会有影响
// }
.img-bg {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.bg {
  position: absolute;
  left: -105px;
  top: -79px;
  z-index: 9999;
  width: 300px;
  height: 300px;
  opacity: 0.4;
}
.title {
  width: 100%;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  padding-top: 10px;
  padding-bottom: 5px;
  text-align: center;
  font-size: 22px;
}
.card {
  width: 100%;
  border-right: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  padding-bottom: 10px;
  text-align: center;
  font-size: 26px;
  color: #000000;
  font-weight: 600;
}
.avatar {
  width: 100%;
  height: 100%;
}
/deep/ .el-dialog__body{padding-top:18px}
/deep/ .el-dialog__header{background:#eeeeee}
/deep/ .el-table tr{
  background-color: rgba($color: #FFFFFF, $alpha: 0.2);
}
</style>
